/**
* PulseBetProgressPeriodData defines the data for the periods in progress bar animation
*
* @typedef PulseBetProgressPeriodData
* @type {type}
* @property {startTime} startTime The game time the period starts
* @property {duration} duration Duration of the period
*/
var PulseBetProgressPeriodData = /** @class */ (function () {
    function PulseBetProgressPeriodData(source) {
        this.startTime = source.startTime;
        this.duration = source.duration;
        this.id = source.id;
        this.periodNumber = source.periodNumber;
    }
    return PulseBetProgressPeriodData;
}());
export { PulseBetProgressPeriodData };
//# sourceMappingURL=PulseBetProgressPeriodData.js.map